import React from "react";
import "./bootstrap.min.css";
import "./Post.css";
import { Avatar } from "@material-ui/core";

function Post({ profilePic, image, username, timestamp, title, message }) {
  return (
    <div class="container">
      <h1>Post</h1>
      <div class="card">
        <div className="post">
          <div className="post__top">
            <Avatar src={profilePic} className="post__avatar" />
            <div className="top__topInfo">
              <h3>{username}</h3>
              <p>{new Date(timestamp?.toDate()).toUTCString()}</p>
            </div>
          </div>
          <div className="post__bottom">
            <h2>{title}</h2>
            <p>{message}</p>
          </div>
          <div class="post__image">
            <img src={image} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Post;
